import {IApplicationReducerData} from "../../../application/types/IApplicationReducerData";

export const getPreferencesFromLeadData = (applicationData: IApplicationReducerData) => {
    const regionId = applicationData.offer?.detail?.region?.parent?.id || applicationData.offer?.detail?.region.id;

    return {
        rooms: applicationData.property?.detail ? {lower: applicationData.property.detail.rooms, upper: applicationData.property.detail.rooms} : undefined,
        budget: applicationData.property?.detail?.price,
        ...(regionId && {regions: [{value: regionId, label: applicationData.offer?.detail?.region.full_name || ""}]})
    };
};
import {IApplicationReducerData} from "../../../application/types/IApplicationReducerData";

export const getPreferencesFromLeadData = (applicationData: IApplicationReducerData) => {
    const regionId = applicationData.offer?.detail?.region?.parent?.id || applicationData.offer?.detail?.region.id;

    return {
        rooms: applicationData.property?.detail ? {lower: applicationData.property.detail.rooms, upper: applicationData.property.detail.rooms} : undefined,
        budget: applicationData.property?.detail?.price,
        ...(regionId && {regions: [{value: regionId, label: applicationData.offer?.detail?.region.full_name || ""}]})
    };
};
